<template>
  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path :fill="fill" d="M21.7131 4.22498C21.5218 4.02498 21.2826 4 21.0435 4H16.0217V1C16.0217 0.45 15.5435 0 15.0174 0H6.9826C6.45651 0 5.97826 0.45 5.97826 1V4H0.956522C0.430435 4 0 4.325 0 4.875V19C0 19.55 0.430435 20 0.956522 20H21.0435C21.5696 20 22 19.55 22 19V4.92499C22 4.64999 21.9044 4.42497 21.7131 4.22498ZM7.8913 2H14.1087V4H7.8913V2ZM20.087 6V11.25H13.3913V10.875C13.3913 10.45 13.0087 10.25 12.6022 10.25H9.3739C8.96738 10.25 8.58479 10.475 8.58479 10.875V11.25H1.88914V6H20.087ZM11.9565 11.75V12.25H10.0435V11.75H11.9565ZM1.91304 18V12.75H8.6087V13C8.6087 13.425 8.99132 13.75 9.39784 13.75H12.6261C13.0326 13.75 13.4152 13.4 13.4152 13V12.75H20.1109V18H1.91304Z" />
  </svg>
</template>

<script>
  export default {
    name: 'thingsIcon',
    props: {
      fill: {
        type: String,
        required: false,
        default: '#29ABE2'
      }
    }
  }
</script>
